/* eslint-disable @typescript-eslint/no-explicit-any */
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export function lastValueFrom<T = any>(observable: Observable<T>): Promise<T> {
	return observable.toPromise();
}

export function firstValueFrom<T = any>(observable: Observable<T>): Promise<T> {
	return observable.pipe(first()).toPromise();
}
